import { defineStore } from 'pinia';

interface CachedView {
  name: string;
  scrollX?: number;
  scrollY?: number;
}

export const useCacheStore = defineStore('cache', {
  state: (): { cachedViews: Array<CachedView> } => ({ cachedViews: [] }),
  actions: {
    addCachedView(view: CachedView) {
      const index = this.cachedViews.findIndex((v) => v.name === view.name);
      if (index === -1) {
        this.cachedViews.push(view);
      } else {
        this.cachedViews.splice(index, 1, view);
      }
    },
    deleteCachedView(name: string) {
      this.cachedViews = this.cachedViews.filter((item) => item.name !== name);
    },
  },
});
